module.exports = __webpack_public_path__ + "static/media/hero-img.619f0cc8.png";